var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"container"},[_c('div',[_c('div',{staticClass:"title"},[_vm._v("支付成功")]),_c('div',{staticClass:"title2"},[_vm._v("订单号："+_vm._s(_vm.orderid))]),_c('div',[_c('button',{staticClass:"btn gradient-btn",on:{"click":_vm.goToOrderDetails}},[_vm._v(" 确定 ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }